import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import LanguageModalContainer from '../../components/SetupSubPageComps/LanguageSetupComps/LanguageModalContainer';
import ShowAllLanguageSetups from '../../components/SetupSubPageComps/LanguageSetupComps/ShowAllLanguageSetups';
import LanguageProvider from '../../contexts/LanguageProvider';

const Languages = () => {
  // rendering language setup page component here
  return (
    <>
      <PageTitle title='Languages Setup' />

      <LanguageProvider>
        <ShowAllLanguageSetups />
        <LanguageModalContainer />
      </LanguageProvider>
    </>
  );
};

export default Languages;
